<div class="sample-padding">
  <ejs-chiplist id="filterChipList" [chips]="chips" (deleted)="chipDeleted($event)" #filterChipList enableDelete="true"
    style="float: left;">
  </ejs-chiplist>
  <button class="btn e-chip e-chip-icon-wrap" (click)="openFilterDialog()" style="float: left;"
    title="{{'i18n.domain.parker-administration.overview.filter-dialog.add-filter-tooltip' | translate}} ">
    <span class="e-btn-icon e-icons icon-add-round e-icon-left"></span>
  </button>
</div>
<ejs-dialog #filterDialog [isModal]="true" [showCloseIcon]="true" [visible]="false">
  <ng-template #header>
    {{'i18n.domain.parker-administration.overview.filter-dialog.title' | translate}}
  </ng-template>
  <ng-template #content>
    <div class="row">
      <div class="col-6">
        <ejs-listbox [dataSource]='filterFieldList' [fields]="fieldList" #fieldsListBox id="fieldsListBox">
          <ng-template #itemTemplate let-data>
            <div >

            </div>
            @if (data.i18nLabel) {
              <div id="data.filterField">
                {{data.i18nLabel | translate}}
              </div>
            }
            @if (!data.i18nLabel) {
              <div>
                {{data.displayName | translate}}
              </div>
            }
            @if (hasFilter(data.displayName)) {
              <span class="filterIcon e-icons e-icon-filter e-filtered"></span>
            }
          </ng-template>
        </ejs-listbox>
      </div>
      <div class="col-6">
        <form id="parkerFilterForm" [formGroup]="filterForm" autocomplete="off">
          <label class="control-label">{{'i18n.domain.parker-administration.overview.filter-dialog.value-title' |
            translate}} </label>
          @if (isTheFieldSelected('Group')) {
            <ejs-dropdownlist id="groups" formControlName="Group" formControlName="Group" [dataSource]="groupTypes"
                      [fields]="enumDropdownSettings"></ejs-dropdownlist>
          }

          @if (isTheFieldSelected('CostCenter')) {
            <input id="CostCenter" name="CostCenter" type="text" autocomplete="off" class="form-control" formControlName="CostCenter"/>
          }

          @if (isTheFieldSelected('Title')) {
            <input id="Title" name="Title" type="text" autocomplete="off" class="form-control" formControlName="Title"/>
          }

          @if (isTheFieldSelected('Workplace')) {
            <input id="workplace" name="workplace" type="text" autocomplete="off" class="form-control" formControlName="Workplace"/>
          }

          @if (isTheFieldSelected('EmploymentPercentage')) {
            <input id="employmentPercentage" name="employmentPercentage" type="number" autocomplete="off" class="form-control" formControlName="EmploymentPercentage"/>
          }

          @if (isTheFieldSelected('IsLinked')) {
            <app-yes-no-group-button id="IsLinked" formControlName="IsLinked" [allowNull]="true"></app-yes-no-group-button>
          }

          @if (isTheFieldSelected('Active')) {
            <app-yes-no-group-button id="Active" formControlName="Active" [allowNull]="true"></app-yes-no-group-button>
          }

          @if (isTheFieldSelected('Billing')) {
            <app-yes-no-group-button id="Billing" formControlName="Billing" [allowNull]="true"></app-yes-no-group-button>
          }

          @if (isTheFieldSelected('HasSubscriptions')) {
            <app-yes-no-group-button id="HasSubscriptions" formControlName="HasSubscriptions" [allowNull]="true"></app-yes-no-group-button>
          }

          @if (isTheFieldSelected('Subscription')) {
            <ejs-dropdownlist id="Subscription" [dataSource]="subscriptionsDropdownValues" [showClearButton]="true"
                      formControlName="Subscription"
                      [fields]="dropdownSettings"></ejs-dropdownlist>
          }

          @if (isTheFieldSelected(this.client.custom1Name)) {
            <input id="Custom1" name="Custom1" type="text" autocomplete="off" class="form-control" formControlName="Custom1"/>
          }

          @if (isTheFieldSelected(this.client.custom2Name)) {
            <input id="Custom2" name="Custom2" type="text" autocomplete="off" class="form-control" formControlName="Custom2"/>
          }

          @if (isTheFieldSelected(this.client.custom3Name)) {
            <input id="Custom3" name="Custom3" type="text" autocomplete="off" class="form-control" formControlName="Custom3"/>
          }

          @if (isTheFieldSelected(this.client.custom4Name)) {
            <input id="Custom4" name="Custom4" type="text" autocomplete="off" class="form-control" formControlName="Custom4"/>
          }

          @if (isTheFieldSelected(this.client.custom5Name)) {
            <input id="Custom5" name="Custom5" type="text" autocomplete="off" class="form-control" formControlName="Custom5"/>
          }

          @if (isTheFieldSelected(this.client.custom6Name)) {
            <input id="Custom6" name="Custom6" type="text" autocomplete="off" class="form-control" formControlName="Custom6"/>
          }

          @if (isTheFieldSelected(this.client.custom7Name)) {
            <input id="Custom7" name="Custom7" type="text" autocomplete="off" class="form-control" formControlName="Custom7"/>
          }

          @if (isTheFieldSelected(this.client.custom8Name)) {
            <input id="Custom8" name="Custom8" type="text" autocomplete="off" class="form-control" formControlName="Custom8"/>
          }

          @if (isTheFieldSelected(this.client.custom9Name)) {
            <input id="Custom9" name="Custom9" type="text" autocomplete="off" class="form-control" formControlName="Custom9"/>
          }
        </form>
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary me-2" (click)="closeFilterDialog()">
      {{'i18n.domain.parker-administration.overview.filter-dialog.cancel-button' | translate}}
    </button>
    <button class="btn btn-primary" (click)="applyFilter()">
      {{'i18n.domain.parker-administration.overview.filter-dialog.apply-filter-button' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
